// Enum describing how deltas are interpreted in comparisons.
// Positive means increases are good, Negative means increases in values are not good
export enum InterpretationValue {
  Negative = -1,
  Positive = 1,
}
